import { render, staticRenderFns } from "./RechargeBalance.vue?vue&type=template&id=6fb01a36&scoped=true&"
import script from "./RechargeBalance.vue?vue&type=script&lang=js&"
export * from "./RechargeBalance.vue?vue&type=script&lang=js&"
import style0 from "./RechargeBalance.vue?vue&type=style&index=0&id=6fb01a36&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb01a36",
  null
  
)

export default component.exports